export default "/iconLeaveNote.svg";